import { ApplicationState } from 'application/redux';
import { goToFirstPage } from 'core/pagination-optimized/redux/actions';
import { connect } from 'react-redux';
import MultipleSearchComponent from './multiple-search-component';
import { clearAllFilters, deleteFilter, toggleShowMoreFilters } from './redux/action';

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
  t: state.i18n.t,
  multipleSearch: state.multipleSearch
});

export default connect(mapStateToProps, {
  toggleShowMoreFilters,
  clearAllFilters,
  deleteFilter,
  goToFirstPage
})(MultipleSearchComponent);
